import { MenuItem } from "@/app/lib/features/menus/menus.types";
import Link from "next/link";
import { FC } from "react";
import FallbackImage from "../FallbackImage";
import { trackInteraction } from "@/app/lib/tracking/interactions";

interface ProductCategoriesButtonProps {
  product: MenuItem;
  onClose?: () => void;
}

const ProductCategoriesButton: FC<ProductCategoriesButtonProps> = ({
  product,
  onClose,
}) => {
  return (
    <Link
      href={`/${product.url}`}
      onClick={() => { trackInteraction("menu", product.id, "click"); onClose?.(); }}
      className="flex group/products flex-col items-center gap-2"
    >
      <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-100 flex items-center justify-center">
        <FallbackImage
          src={product.image_url}
          alt={product.name}
          width={64}
          height={64}
          className="w-full h-full object-cover"
          sizes="64px"
        />
      </div>
      <p className="text-xs font-normal text-gray-800 group-hover/products:text-main group-hover/products:underline cursor-pointer text-center w-full">
        {product.name}
      </p>
    </Link>
  );
};

export default ProductCategoriesButton;